module.exports = __webpack_public_path__ + "e8bc8320e86ebfe4321fc62ee6ea6058.pdf";